import React from 'react';
import SimplifiedPremierLeagueApp from './SimplifiedPremierLeagueApp';

function App() {
  return (
    <div className="App">
      <SimplifiedPremierLeagueApp />
    </div>
  );
}

export default App;